import * as Scrivito from "scrivito"
import { AuthContextType } from "shared/context/AuthContext"
import { LOGIN_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

export function useLogin({
  isAuthenticated
}: Pick<AuthContextType, "isAuthenticated">) {
  const { openOverlay: openLoginOverlay } = useOverlay(LOGIN_OVERLAY)

  const login = useEvent(() => {
    if (!isAuthenticated) {
      openLoginOverlay(null)
    }
  })

  const logout = useEvent(() => {
    Scrivito.logout(window.location.origin)
  })

  return { login, logout }
}
